import React, { FunctionComponent } from 'react';
import {
	Text,
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableHeaderCell,
	TableBody,
	TableFoot,
} from '@mlc/web-ui-toolkit';
import { asCurrency, asPercentage } from '../../../../../common/formatter';
import { PlanInvestments } from '../../../../../../logic/domains/planProfile.domain';
import planProfileTestIds from '../../PlanProfile.elements';

interface Props {
	date: string;
	planInvestments: PlanInvestments;
}

const Funds: FunctionComponent<Props> = ({ date, planInvestments }) => (
	<>
		{planInvestments.investmentFunds.length > 0 && (
			<>
				<Text fontWeight="semibold" marginBottom={6} marginTop={6} el="h5">
					Investor Balances By Invesment Fund (as at {date})
				</Text>
				<Table
					variant="bottomLines"
					border="mlcBorderThin"
					borderColor="mlcAlmostWhite"
					layout="fixed"
					data-id={planProfileTestIds.planInvestmentFunds}
				>
					<TableHead>
						<TableRow>
							<TableHeaderCell colSpan="2">Fund</TableHeaderCell>
							<TableHeaderCell colSpan="1" align="right">
								Amount
							</TableHeaderCell>
							<TableHeaderCell colSpan="1" align="right">
								Percentage
							</TableHeaderCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{planInvestments.investmentFunds.map((investmentFund, index) => (
							<TableRow key={investmentFund.name + index}>
								<TableCell colSpan="2">{investmentFund.name}</TableCell>
								<TableCell colSpan="1" align="right">
									{asCurrency(investmentFund.balance)}
								</TableCell>
								<TableCell colSpan="1" align="right">
									{asPercentage(investmentFund.percentage)}
								</TableCell>
							</TableRow>
						))}
					</TableBody>
					<TableFoot>
						<TableRow>
							<TableCell scope="row" el="th" colSpan="2">
								Total
							</TableCell>
							<TableCell colSpan="1" align="right">
								{asCurrency(planInvestments.totalFundsAmount)}
							</TableCell>
							<TableCell colSpan="1" align="right">
								{asPercentage(planInvestments.totalFundsPercentage, false)}
							</TableCell>
						</TableRow>
					</TableFoot>
				</Table>
			</>
		)}
	</>
);

export default Funds;
